@if (socialTheme){
    <agpr-button
        class="agpr-contentLibraryPanel-upload"
        [icon]="'fa-regular fa-duotone fa-pen'"
        [style]="buttonTypes.icon"
        [tooltip]="buttonTooltip"
        (click)="openContentLibrary()"
    ></agpr-button>
} @else {
    <div class="agpr-contentLibraryPanel">
        <div class="agpr-contentLibraryPanel-field" [ngClass]="{'agpr-contentLibraryPanel-field-checkBox' : value.showAltText}">
            <agpr-panel [header]="field.label">
                <div class="agpr-blockForm panel-container">
                    <ng-template #formFieldsContainer></ng-template>
                    <div class="agpr-contentLibraryPanel-field-noImage">
                        <span>
                            {{ 'Mention.editDialog.attachments.placeholder' | localize }}
                        </span>
                    </div>
                    <div class="agpr-contentLibraryPanel-upload">
                        <agpr-split-button
                            [id]="'contentLibraryPanel'"
                            [icon]="uploadIcon"
                            panelPositionY="bottom"
                            panelPositionX="right"
                            agprTooltip="Discover.distribution.imageUpload.tooltip"
                            tooltipPosition="top"
                            [options]="uploadOptions"
                        ></agpr-split-button>
                    </div>
                </div>

                <div class="agpr-contentLibraryPanel-field-container">
                    @if (value.url || value.url === '') {
                        <div class="agpr-contentLibraryPanel-field-files">
                            <div class="agpr-contentLibraryPanel-field-files-item">
                                <div class="agpr-contentLibraryPanel-field-thumbnail-container">
                                    @if (value.url && !value.hasError && !value.noThumbnail
                                        && (value.mimeType === 'image/png' || value.mimeType === 'image/jpeg' || value.type === 'image/png' || value.type === 'image/jpeg')) {
                                        <img
                                            [src]="value.url + '?isThumbnail=true'"
                                            [alt]="value.altText"
                                            class="agpr-contentLibraryPanel-field-thumbnail-container--image"
                                            (error)="value.noThumbnail=true"
                                        >
                                    } @else if (value.url && !value.hasError) {
                                        <img
                                            [src]="value.url"
                                            class="agpr-contentLibraryPanel-field-thumbnail-container--image"
                                            (error)="value.hasError=true"
                                        >
                                    } @else {
                                        <span class="agpr-contentLibraryPanel-field-url-thumbnail-placeholder fa-regular fa-duotone fa-file-image"></span>
                                    }
                                </div>
                                <div class="agpr-contentLibraryPanel-field-fileContainer">
                                    @if (value.name) {
                                        <span class="agpr-contentLibraryPanel-field-fileName">{{ value.name }}</span>
                                    } @else {
                                        <agpr-text-input
                                            class="agpr-contentLibraryPanel-field-url-textInput"
                                            [id]="'contentLibraryPanel' + '.textFieldInput'"
                                            [(ngModel)]="value.url"
                                            (input)="onUrlInput($event)"
                                            (blur)="onUrlBlur()"
                                            [placeholder]="field.placeholder | localize"
                                            [ariaDescribedBy]="id + '_error'">
                                        </agpr-text-input>

                                        @if (value.errorMessage && value.touched) {
                                            <agpr-form-message [id]="'contentLibraryPanel' + '_file_error'">
                                                {{ value.errorMessage | localize }}
                                            </agpr-form-message>
                                        }
                                    }

                                    <div class="agpr-contentLibraryPanel-field-altText" [ngClass]="{'agpr-contentLibraryPanel-field-altTextChecked' : value.showAltText}">
                                        <agpr-checkbox
                                            [id]="'contentLibraryPanel'"
                                            [(ngModel)]="value.showAltText"
                                            [binary]="true"
                                            (onChange)="changeAltText(value)"
                                            [label]="'Common.forms.altText'"
                                        >
                                        </agpr-checkbox>
                                        @if (value.showAltText) {
                                            <div class="agpr-contentLibraryPanel-field-inputText">
                                                <agpr-text-input
                                                    [id]="'contentLibraryPanel.altTextInput'"
                                                    [(ngModel)]="value.altText"
                                                    [maxLength]="255"
                                                    [bottomMargin]="false"
                                                    [placeholder]="'Common.forms.enterAltText'"
                                                    (ngModelChange)="emitChanges()">
                                                </agpr-text-input>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    }@else {
                        <agpr-message
                            [severity]="messageSeverityEnum.noContent"
                            [useWhiteBg]="true"
                            [id]="'contentLibraryPanel'"
                        >
                            {{'Mention.workbench.image.noImage' | localize}}
                        </agpr-message>
                    }
                </div>
            </agpr-panel>
        </div>
    </div>
}


